import script from "./Links.vue?vue&type=script&setup=true&lang=ts"
export * from "./Links.vue?vue&type=script&setup=true&lang=ts"

import "./Links.vue?vue&type=style&index=0&id=6ef44f8d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef44f8d"]])

export default __exports__